import { useMemo } from "react";
import { StoreEvent } from "../models/SearchResult";

export default function StoreEventRow(props: { storeEvent: StoreEvent }) {
    const event = props.storeEvent;
    const store = props.storeEvent.store;

    const mapUrl = useMemo(() => {
        const concatAddress = `${event.address1 ?? ''}${event.address2 ?? ''}${event.address3 ?? ''}${event.address4 ?? ''}`;
        return "https://www.google.com/maps/search/?api=1&query=" + encodeURIComponent(concatAddress);
    }, [event])

    const areaCodeColor = useMemo(() => {
        if (event.prefecture <= 0) {
            return "region-0-gray";
        } else if (event.prefecture <= 7) {
            return "region-1-royalblue";
        } else if (event.prefecture <= 14) {
            return "region-2-green";
        } else if (event.prefecture <= 23) {
            return "region-3-aqua";
        } else if (event.prefecture <= 30) {
            return "region-4-orangered";
        } else if (event.prefecture <= 35) {
            return "region-5-pink";
        } else if (event.prefecture <= 39) {
            return "region-6-purple";
        } else if (event.prefecture <= 47) {
            return "region-7-orange";
        }
        return '';
    }, [event]);

    return <li className='type-post_event_row'>
        <div className="wp-block-osica-osica-query-loop-event-detail">
            <div className={`prefecture ${areaCodeColor}`}>
                {event.prefecture_name}
            </div>
            <div className="event-info-root">
                <div className="shop-info">
                    <div className="date">{event.event_begin_at}</div>
                    <div className="shop-stack">
                        <div className="shop-title">{store.name}</div>
                        <div className="phone-number text-muted">
                            <a
                                className="btn btn-dark btn-sm address-map"
                                target="_blank"
                                rel="nofollow noopener noreferrer"
                                href={mapUrl}>
                                MAP
                            </a>
                            {
                                event.contact_email ? <span className="d-block" style={{ wordBreak: 'break-all' }}>
                                    <i className="fa-solid fa-envelope"></i> {event.contact_email}
                                </span> : null
                            }
                            {
                                event.contact_telephone ? <span className="d-inline-block" style={{ marginRight: event.contact_twitter || event.url ? '0.5rem' : 0, wordBreak: 'break-all' }}>
                                    <i className="fa-solid fa-phone"></i> {event.contact_telephone}
                                </span> : null
                            }
                            {
                                event.contact_twitter ? <a href={`https://twitter.com/${event.contact_twitter}`} target="_blank" rel="nofollow noopener noreferrer" className="d-inline-block" style={{ marginRight: event.url ? '0.5rem' : 0, wordBreak: 'break-all' }}>
                                    @{event.contact_twitter}
                                </a> : null
                            }
                            {
                                event.url ? <a href={event.url} target="_blank" rel="nofollow noopener noreferrer">
                                    Web <i className="fa-solid fa-arrow-up-right-from-square"></i>
                                </a> : null
                            }
                        </div>
                    </div>
                    <a
                        className="btn btn-dark btn-sm address-map"
                        target="_blank"
                        rel="nofollow noopener noreferrer"
                        href={mapUrl}>
                        MAP
                    </a>
                </div>
                <dl className="event-info" style={{ flexWrap: 'wrap' }}>
                    <dt className="term"><span className="badge rounded-pill bg-primary">参加費</span></dt>
                    <dd className="fee">{event.fee}</dd>
                    <dt className="term"><span className="badge rounded-pill bg-primary">人数</span></dt>
                    <dd className="fee">{event.number_of_people}人</dd>
                    {
                        <PrizeCondition prizeCondition={event.prize_condition} />
                    }
                </dl>
            </div>
        </div>
    </li >
}

function PrizeCondition(props: { prizeCondition?: string | null }) {
    if (!props.prizeCondition) {
        return null;
    }

    return <>
        <dt className="term"><span className="badge rounded-pill bg-primary" title="配布条件">配布</span></dt>
        <dd className="fee">{props.prizeCondition}</dd>
    </>
}